//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "TouristTabBar",
  components: {},
  props: ["tourist-active"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    setActive: function setActive(value) {
      this.$emit("set-active", value);
    }
  },
  watch: {},
  filters: {}
};